import { io } from "socket.io-client";

const socket = io("https://invown-noti-service-socket-jnfdip3m7a-uc.a.run.app", {
  path: "/api/socket.io",
  transports: ["websocket"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  withCredentials: false,
});

export default socket;
